// Which MAAP portal an account belongs to. The internal accounts are listed in full
// below: an organization's account number may also begin with 'SSC' or 'PCF' (it is
// their own name, not ours), so only these exact codes are internal and everything
// else is a normal organization. Same mapping as the app's utils/orgType.js and the
// backend's get_account_type().
export type Portal = 'org' | 'pcf' | 'ssc';

const SSC_ACCOUNTS = ['SSC01', 'SSC02', 'SSC03'];
const PCF_ACCOUNTS = ['PCF01', 'PCF02'];

export const portalFromOrgCode = (orgCode?: string): Portal | null => {
  const code = (orgCode || '').trim().toUpperCase();
  if (!code) return null;
  if (SSC_ACCOUNTS.includes(code)) return 'ssc';
  if (PCF_ACCOUNTS.includes(code)) return 'pcf';
  return 'org';
};
